<template>
  <div>
    <b-container fluid class="pb-5 card-management">
        <b-row>
          <b-col xl="12" class="mb-2">
            <h3 class="pl-3 pt-3">{{ $t('Card Management') }}</h3>
            <div class=" mb-4">
              <div class="row">
                <div class="col-12">
                  <step-container 
                    :current_step="3"
                    :step_list="stepList"
                  ></step-container>
                </div>                
              </div>

              <b-row>
                <b-col xl="8" class="mb-5">
                  <div class="block-item p-3 mb-4 pb-4">
                    <h3>{{ $t('Transaction Summary') }}</h3>
                    <div class="block-item mt-3 bg-grey-gradient">
                      <table class="w-100 px-2 fz-16">
                        <tr>
                          <td class="text-grey2 pb-2">{{ $t('Card Fee') }}</td>
                          <td class="text-right text-grey3 fw-500 pb-3">USD {{ getResult(card_fee) }}</td>
                        </tr>
                        <!-- <tr>
                          <td class="text-grey2">Deposit Amount (USD)</td>
                          <td class="text-right text-grey3 fw-500 pb-3">
                            <MaskAmount class="form-input amount ml-auto" @set-price="changePrice($event)" :bus="deposit"></MaskAmount>
                            <div v-if="error.amount" class="invalid-feedback amount ml-auto d-block mb-3">
                            {{$t(error.amount,{amount:this.minimum_amount})}}
                          </div>
                          </td>
                        </tr> -->
                        <tr>
                          <td class="text-grey2">{{ $t('Delivery Fee') }}</td>
                          <td class="text-right text-grey3 fw-500 pb-3">USD {{ getResult(data.shipping_fee) }}</td>
                        </tr>
                        <!-- <tr>
                          <td class="text-grey2">Deposit Fee ({{ getResult(fee) }}%)</td>
                          <td class="text-right text-grey3 fw-500 pb-3">USD {{ getResult(amount*fee/100)  }}</td>
                        </tr> -->
                        <!-- <tr>
                          <td class="text-grey2">Total to Deposit</td>
                          <td class="text-right text-orange2 fw-600 fz-20 pb-3">USD {{ getResult(parseFloat(amount)-parseFloat(card_fee)-(amount*fee/100)) }}</td>
                        </tr> -->
                      </table>
                    </div>
                  </div>
                  <div class="block-item p-3 mb-4">
                    <h3>{{ $t('Deposit Info') }}</h3>
                    <div class="form-group mb-3 mt-4 p-3">
                      <b-row>
                        <b-col sm="12" md="6" class="mb-4">
                          <label>{{ $t('TRX Hash') }}</label>
                          <input type="text" v-model="trx_hash" class="form-control" :placeholder="$t('Fill TRX Hash')" @keydown="onChange('trx_hash')"/>
                          <div v-if="error.trx_hash" class="invalid-feedback d-block mb-3">
                            {{$t(error.trx_hash)}}
                          </div>
                        </b-col>
                        <b-col sm="12" md="6" class="mb-4">
                          <label class="text-grey2">{{ $t('Total Amount') }}</label>
                          <div class="text-orange2 fw-600 fz-20">{{ getResult(parseFloat(card_fee)+parseFloat(data.shipping_fee)) }}</div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="12" md="12">
                          <label>{{ $t('Photo (Optional)') }}</label>
                          <div class="photo-wrapper rounded text-center">
                            <div v-if="image" class="position-relative d-inline-block">
                                <img :src="image" class="doc_image">
                                <button type="button" class="btn-remove" @click="removeImage()">x</button>
                            </div>
                            <div v-else class="d-flex align-items-center justify-content-center">
                                <div class="btn-choose-photo border-0 m-0 p-0 w-100 max-w-100">
                                    <button type="button" class="btn-outline-grey-dashed bg-grey-gradient d-flex flex-column align-items-center justify-content-center w-100 fz-14 fw-400 py-5">
                                        <img :src="`${publicPath}/img/rcp/icon/upload.png`" class="w-auto">
                                        <div><a class="fw-600 fz-14" href="#">{{ $t('Click to upload') }}</a>&nbsp;<span>{{ $t('or drag and drop here') }}</span></div>
                                        <div>{{ $t('PNG, JPG or JPEG') }}</div>
                                    </button>
                                    <FileComponent @file-updated="captureFile($event)" :key="'uploadReceipt'"></FileComponent>
                                </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <b-row class="d-flex mx-1">
                    <router-link to="/fill-in-details" class="btn btn-previous d-block mr-auto" tag="button">{{ $t('Previous') }}</router-link>
                    <button @click="submitRequest()" class="btn btn-submit d-block">{{ $t('Submit') }}</button>
                  </b-row>
                </b-col>
                <b-col xl="4">
                  <div class="block-item wallet-card p-3">
                    <h3 class="mb-3">{{ $t('Wallet Address') }}</h3>
                    <div class="text-align-center">
                      <div class=" bg-white mb-3">
                        <div class="QRimage payment-qr">
                          <qr-code :text="qr_code" color="#000000"></qr-code>
                        </div>
                      </div>
                      <div class="wallet-address d-flex align-items-center pl-3 mt-3 mb-0" style="word-break: break-word;">
                        <div class="w-100 fz-14 fw-500 text-grey">{{ qr_code }}</div>
                        <button @click="copyText()" class="btn flat-button p-4 text-orange2">
                          {{ $t('Copy') }}
                        </button>
                      </div>
                    </div>

                  </div>
                  <div class="choosen-card mt-4">
                    <div class="d-flex align-items-center justify-content-between ">
                      <h3>{{ $t('Your Card') }}</h3>
                      <div class="label-card">
                        <div class="">{{ $t(data.type) }}</div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="card-info w-65">
                        <small>{{ $t('Card Type') }}</small>
                        <p>{{ $t(data.name) }} </p>
                      </div>
                      <div class="card-info">
                        <small>{{ $t('Card Fee') }}</small>
                        <p>{{ card_fee_currency }} {{ card_fee }}</p>
                      </div>
                    </div>
                    
                    <img :src="data.image" class="w-100" />
                  </div>
                </b-col>
              </b-row>
              <b-modal id="complete-card-management" title="CompleteMessage" @hide="onHideModal">
                <template #modal-title>
                  {{ $t('Completed Message') }}
                </template>
                <b-row class="d-flex justify-content-center complete-card">
                  <b-col sm="12" md="6" class="my-4   text-center"> 
                    <svg width="100" height="100" class="checklist-complete">
                      <circle fill="#f8c617" stroke="none" stroke-width="10" cx="50" cy="50" r="46.5" class="circle" stroke-linecap="round"/>
                      <polyline fill="none" stroke="#fff" stroke-width="6" points="22,53.5 43,71 76,33" stroke-linecap="round" stroke-linejoin="round" class="tick" />
                    </svg>
                  </b-col>
                  <b-col sm="12" md="9" class="my-4   text-center"> 
                    <h1>{{ $t('Hooray your card request has been received!') }}</h1>
                    <div class="mt-3 mb-4">
                      {{ $t('Our admin team will review the submission request.') }}<br>
                      {{ $t('Thank you for your patience!') }}
                    </div>
                    <button @click="onHideModal" class="btn btn-orange">{{ $t("Back to Dashboard") }}</button>
                  </b-col>
                </b-row>  
              </b-modal>
              
              
            </div>
          </b-col>
        </b-row>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
  import stepContainer from "@/components/CardManagement/stepContainer";

  import Vue from 'vue'
  import FileComponent from "@/components/FileComponent";
  import MaskAmount from "@/components/Mask/MaskAmount";
  import VueQRCodeComponent from 'vue-qrcode-component';
  import Common from '@/services/Common';
  import LoaderComponent from "@/components/LoaderComponent";
  import { Carousel3d, Slide } from 'vue-carousel-3d';
  import confetti from "@/assets/js/confetti.js";

  Vue.component('qr-code', VueQRCodeComponent);

  var count = 200;
  var defaults = {
    origin: { x: .5, y:.6 }
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    });
  }

  export default {
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        environment : process.env.VUE_APP_ENVIRONMENT,
        currency:process.env.VUE_APP_CURRENCY,
        minimum_amount:process.env.VUE_APP_MINIMUM_DEPOSIT,
        stepList:["Choose Card Product","Fill in Details", "Payment"],
        selected_currency:'',
        approximately:0,
        isSubmit:false,
        data:{},
        deposit : new Vue(),
        amount:0,
        fee : 0,
        card_fee:0,
        shipping_fee:0,
        card_fee_currency : '',
        code:'',
        rate:0,
        trx_hash:'',
        card_id:'',
        qr_code : "",
        isLoading:false,
        image   : '',
        error   : {
          amount  : '',
          trx_hash : ''
        }
      }
    },
    components: {
      stepContainer,
      MaskAmount,
      FileComponent,
      LoaderComponent,
      Carousel3d,
      Slide
    },
    methods:{
      changePrice(event){
        this.error.amount = '';
        this.amount = event;
        console.log(this.amount);
        console.log(this.minimum_amount);
        if(this.amount<parseFloat(this.minimum_amount)){
          this.error.amount = "Minimum Amount is USD {amount}";
        }
        else if((this.amount-this.card_fee-this.shipping_fee)<0){
          this.error.amount = "Amount should be more then 0";
        }
      },
      submitRequest(){
        if(!this.isSubmit){
          this.isSubmit = true;
          const file = this.image?[{file:this.image}]:null;

          Common.card_req_new({
            currency:this.data.currency,
            card_type:this.data.card_type,
            embossed_name:this.data.embossed_name,
            country_code:this.data.country_code,
            state_code:this.data.state_code,
            city_name:this.data.city_name,
            postal_code:this.data.postal_code,
            trx_hash:this.trx_hash,
            address:this.data.address,
            provider_id:this.data.provider_id
          },file).then(response=>{
            if(response.status == 200){
              this.isSubmit = false;
              this.showModal();
            }
          }).catch(err => {
            this.isSubmit = false;
            this.checkError(err);
          });
        }
      },
      onHideModal(){
        this.$router.push({ name: 'card-management'});
      },
      showModal(){
        this.$bvModal.show('complete-card-management');
        setTimeout(function(){
          fire(0.25, {
            spread: 26,
            startVelocity: 55,
          });
          fire(0.2, {
            spread: 60,
          });
          fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8
          });
          fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2
          });
          fire(0.1, {
            spread: 120,
            startVelocity: 45,
          });
        },500);
      },
      getResult(amount){
        if(amount>0){
          return parseFloat(amount).toFixed(2);
        }
        else{
          return 0;
        }
      },
      onChange(name){
        this.error[name]='';
      },
      copyText(){
        navigator.clipboard.writeText(this.qr_code);
        this.$notify({
        type: 'success',
        text: this.getMessage('Copy')
        })
      },
      getMessage: function (key) {
        return this.$t(key)
      },
      removeImage(){
        this.image="";
      },
      captureFile($event) {
        this.image = $event.previewBase64;
      },
      fatchData(){
        Common.paymentAccount().then(response => {
          if(response.status == 200){
            this.qr_code = (response.data.data)?response.data.data.to_address_card:'';
          }
        }).catch(err => {
          this.checkError(err);
        });
      },
      checkError(err){ 
        try{
          const response = err.response;
          if(response.status == 400){
            let err_msg = [];
            let check = true;
            Object.keys(response.data.data).forEach((key) => {
              const index = key.replace('cardrequest-','');
              if(this.error[index]!=undefined){
                check = false;
                this.error[index] = response.data.data[key][0];
              }
              else{
                err_msg.push(response.data.data[key][0]);
              }
            });
            if(check){
              this.$swal({
                icon: 'error',
                text: err_msg.join(", ")
              });
            }
          }         
          else if(response.status == 401 && response.data.name == "Unauthorized"){
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  this.$router.push({ 
                    path: '/login', 
                  });
                }
          else{
            var msg = (response.data)?response.data.message:err.message;
            this.$notify({
              type: 'warn',
              text: msg
            })
          }
        }catch(e){
          console.log(err);
        }
      }
    },
    mounted(){
      var self = this;
      this.data = this.$route.params;
      if(!this.data.card_type){
        this.$router.push({ name: 'order-card'});
      }
      else{
        this.card_fee_currency = this.data.card_fee_currency;
        this.card_fee = this.data.card_fee;
        this.shipping_fee = this.data.shipping_fee;
        this.fee = this.data.fee;

        this.data.image = this.publicPath+"/img/rcp/card/background-7.png";

        let image = this.publicPath+"/img/rcp/card/background-7.png";

        if(this.data.card_type == "physical" && this.data.currency == "HKD"){
          image = this.publicPath+"/img/rcp/card/Card_HKD.png";
        }
        else if(this.data.card_type == "virtual"){
          image = this.publicPath+"/img/rcp/card/background-6.png";
        }

        this.data.image = image;

        this.$nextTick(function () {
          self.fatchData();
        });
      }
    }
  };
</script>

